module.exports = __webpack_public_path__ + "static/img/ag.cce32c73.svg";